import { GeneralTexts } from '../../language/Texts';
import { CommonComponentProps } from '../../models/CommonComponentProps';
import { EmailBodyType } from '../../models/EmailBodyType.enum';
import { getMailBody, openEmailSender } from '../../utils/EmailSender';
import './Contact.scss';

function Contact({ articleDescriptionS, generalAttributeList }: CommonComponentProps) {

    let mailSubject = `${GeneralTexts.request}: ${articleDescriptionS} - ${GeneralTexts.digitalTagPlate}`
    if (generalAttributeList.componentType) {
        mailSubject = `${GeneralTexts.request}: ${articleDescriptionS} - ${GeneralTexts.digitalTagPlate} | ${generalAttributeList.componentType}`
    }
    const mailBody = getMailBody(generalAttributeList, EmailBodyType.CONTACT, articleDescriptionS)

    return (
        <div className='contact_wrapper'>
            <div className="contact_text_wrapper">
                <div className="contact_title">{GeneralTexts.connectWithUs}</div>
                <div className="contact_text">BWT AQUA AG</div>
                <div className="contact_text">Hauptstrasse 192</div>
                <div className="contact_text">4147 Aesch, Schweiz</div>
                <div className="contact_text">T +41 61 755 88 99</div>
                <div className="contact_text mail_text"
                    data-testid="contact_mail"
                    onClick={() => openEmailSender(mailSubject, mailBody)}
                >	
                info@bwt-aqua.ch</div>
            </div>
        </div>
    )
}

export default Contact
